import React, { useEffect, useRef } from 'react';
import MultiOrgPickerComponent from './MultiOrgPicker';
import { useMultiOrgCookies } from '../../hooks/useMultiOrgCookies';
import { isEqual } from 'lodash';
import { useZdsMenuHost } from '../hooks/useZdsMenuHost';
import {
  safeAddEventListener,
  safeRemoveEventListener,
} from '../../utils/safeEventListener';

interface MultiOrgControllerProps {
  menuType?: string;
  reloadPage: () => void;
  isVisible?: boolean;
  navRootElement: Element | null;
}

const MultiOrgController = ({
  menuType,
  reloadPage,
  isVisible = true,
  navRootElement,
}: MultiOrgControllerProps) => {
  const menuElement = useZdsMenuHost({
    // Exclude the multi-entity host which uses the same custom element tag
    selector: 'z-multi-org-menu:not([entity])',
    isVisible,
    navRootElement,
  });
  const { selectedOrgIds } = useMultiOrgCookies();
  const originalOrgIds = useRef(selectedOrgIds);

  useEffect(() => {
    const handleDropdownClose = (event: Event) => {
      if (!(event as any).detail?.entity) {
        if (!isEqual(originalOrgIds.current?.sort(), selectedOrgIds?.sort())) {
          reloadPage();
        }
      }
    };

    // Registration has to go through the same implementation as the removal
    // below, or the two would work on different listener registries.
    safeAddEventListener(
      document,
      'multi-org-picker-dropdown-close',
      handleDropdownClose,
    );

    return () => {
      safeRemoveEventListener(
        document,
        'multi-org-picker-dropdown-close',
        handleDropdownClose,
      );
    };
  }, [reloadPage, selectedOrgIds]);

  if (!isVisible || !menuElement) {
    return null;
  }

  return (
    <MultiOrgPickerComponent
      menuElement={menuElement}
      menuType={menuType}
      reloadPage={reloadPage}
    />
  );
};

export default MultiOrgController;
